export enum WebSocketTypes {
  CONNECT = "@@SOCKET/CONNECT",
}
